import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {useHistoryPageState} from '@aboutyou/history-page-state';
import {useHasScrolledDown, useInViewEffect} from '@aboutyou/ui-components';

const HISTORY_STATE_RECOS_IN_VIEW_KEY = 'history_state_recos_in_view_key';

export const useIsRecoRequestEnabled = <ElementType extends HTMLElement>(
  defaultEnabled = false,
) => {
  const scrollToLoadRecosEnabled = useIsFeatureActive(
    'enable_scroll_to_load_adp_recos',
  ).isActive;

  const hasScrolledDown = useHasScrolledDown();
  const [requestEnabled, setRequestEnabled] = useHistoryPageState(
    defaultEnabled,
    {
      uniqueKey: HISTORY_STATE_RECOS_IN_VIEW_KEY,
    },
  );

  const {ref} = useInViewEffect<ElementType>(
    inView => {
      if (scrollToLoadRecosEnabled) {
        if (inView && hasScrolledDown) {
          // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
          setRequestEnabled(true);
        }
      } else {
        if (inView) {
          // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
          setRequestEnabled(true);
        }
      }
    },
    {
      threshold: 0,
      triggerOnce: false,
      rootMargin: '250px',
    },
  );

  return {ref, requestEnabled: defaultEnabled || requestEnabled};
};
